import styled from "@emotion/styled";
import React from "react";

import {greenMiddle} from "../../../const/color";
import {Table, TableContainer, Th} from "../../atoms/tables/table";

const Thead = styled.thead`
    background-color: ${greenMiddle};
`;
type TemplateThProps = {
    width?: number;
    required?: boolean;
};
const TemplateTh = styled(Th)<TemplateThProps>(({width, required}) => ({
    whiteSpace: "nowrap",
    ...(width && {width: `${width}px`, minWidth: `${width}px`}),
    ...(required && {
        "&::after": {
            content: '"*"',
            color: "red",
            marginLeft: "0.1em",
        },
    }),
}));

export type TableData = {
    id: string;
    [key: string]: string | JSX.Element;
};

type Props = {
    areaLabel?: string;
    isFill?: boolean;
    columns: {
        label: string;
        width?: number;
        required?: boolean;
    }[];
    children: React.ReactNode;
};

export const TableLayout = ({columns, children, areaLabel = "", isFill}: Props) => {
    return (
        <TableContainer isFill={isFill}>
            <Table aria-label={areaLabel}>
                <Thead>
                    <tr>
                        {columns.map(({label, width, required = true}, index) => (
                            <TemplateTh key={index} width={width} required={required}>
                                {label}
                            </TemplateTh>
                        ))}
                    </tr>
                </Thead>
                <tbody>{children}</tbody>
            </Table>
        </TableContainer>
    );
};
